import { StorageObjectGroupType, StorageObjectGroupTypeLabels, type StorageSpaceRecord } from '@navio/nsdk';
import { getLabelMapFromEntries } from '../options/choiceOptions';
import { pluralizeWithValue } from '../string/string';

/** Convention: 1 wheel set = 4 wheels for cargo capacity and stop timing. */
export const WHEELS_PER_SET = 4;

/** What one stored item of a kind is called. */
export const STORED_ITEM_WORD: Record<StorageObjectGroupType, string> = {
  [StorageObjectGroupType.CAR_WHEELS]: 'wheel set',
  [StorageObjectGroupType.CAR_TIRES]: 'tire'
};

export const STORAGE_OBJECT_GROUP_TYPE_LABEL = getLabelMapFromEntries(
  StorageObjectGroupType,
  StorageObjectGroupTypeLabels
);

/** A unit with no kind takes any kind; one with a kind takes only that kind. */
export const storageUnitTakes = (
  { stores }: { stores?: StorageObjectGroupType | null },
  kinds: StorageObjectGroupType[]
): boolean => stores == null || kinds.every((kind) => kind === stores);

/** Share of the space that is used, rounded; full when the space is zero. */
export const getStorageSpacePercent = ({ capacity, used }: StorageSpaceRecord): number =>
  capacity > 0 ? Math.round((used / capacity) * 100) : 100;

/** "48/60 wheel sets (80% full)". */
export const formatStorageSpaceUsage = (space: StorageSpaceRecord): string =>
  `${space.used}/${pluralizeWithValue({ value: space.capacity, word: STORED_ITEM_WORD[space.stores] })} (${getStorageSpacePercent(space)}% full)`;

/** "Fits 12 more wheel sets". */
export const formatStorageSpaceRoom = ({ stores, capacity, used }: StorageSpaceRecord): string =>
  `Fits ${pluralizeWithValue({ value: Math.max(0, capacity - used), word: `more ${STORED_ITEM_WORD[stores]}` })}`;

/** What a unit stores: its kind, or "Any kind". */
export const formatStorageUnitStores = (stores?: StorageObjectGroupType | null): string =>
  stores == null ? 'Any kind' : STORAGE_OBJECT_GROUP_TYPE_LABEL[stores];
